var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from "lit";
import { customElement, property } from "lit/decorators.js";
let BasicModal = class BasicModal extends LitElement {
    constructor() {
        super(...arguments);
        this.open = false;
    }
    handleClose() {
        this.open = false;
        this.remove();
    }
    render() {
        return html `
        <div class="modal ${this.open ? 'open' : ''}">
            <basic-card>
            <simple-button
                label="x"
                variant="danger"
                @button-click="${this.handleClose}"
                size="small"
            ></simple-button>
            <slot></slot>
            </basic-card>
        </div>
    `;
    }
};
BasicModal.styles = css `
    .modal {
        display: none;
        position: fixed;
        z-index: 1000;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        overflow: auto;
        background-color: rgba(0, 0, 0, 0.4);
    }
    
    .modal.open {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    simple-button {
        position: absolute;
        top: 10px;
        right: 10px;
    }
    `;
__decorate([
    property({ type: Boolean })
], BasicModal.prototype, "open", void 0);
BasicModal = __decorate([
    customElement("basic-modal")
], BasicModal);
export { BasicModal };
//# sourceMappingURL=BasicModal.js.map